
import Vue from 'vue';

export default Vue.extend({
  name: 'SkeletonLoader',

  props: {
    loading: { type: Boolean, default: false },
  },

});
